import React, { Component } from 'react';
import { connect } from 'react-redux';
import QRCode from 'qrcode.react';
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCopy } from '@fortawesome/free-regular-svg-icons';
import ToastHandler from '../../components/toasthandler';
import Loader from '../../components/loader';
const Big = require('big.js');

import {
  fetchAddress,
  createAddress,
} from '../../actions';

class DepositModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showOld: false,
      addressLoaded: false,
      metaMaskAccount: null,
      depositAmount: 0.0,
      metaMaskInvalidNet: false,
      depositType: 'VAULTORO',
      metaMaskSuccess: false,
      walletAddresses: [],
      createdAddress: '',
    };
    this.newAddress = this.newAddress.bind(this);
    this.triggerMetaMaskDeposit = this.triggerMetaMaskDeposit.bind(this);
    this.metaMaskCancel = this.metaMaskCancel.bind(this);
    this.fetchBalance = this.fetchBalance.bind(this);
    this.handleMetaMaskDepositAmount = this.handleMetaMaskDepositAmount.bind(this);
    this.copyToClipboard = this.copyToClipboard.bind(this);
    this.ethereum = (window.ethereum && window.ethereum.isMetaMask) ? window.ethereum : undefined; // check if ethereum object is present, and is MetaMask
    this.changeEth = this.changeEth.bind(this)
    this.checkNetwork = this.checkNetwork.bind(this);
    this.onChainChange = this.onChainChange.bind(this)
    this.handleAddresses = this.handleAddresses.bind(this)
  }

  async componentDidMount() {
    const { dispatch, asset } = this.props;
    const data = {
      asset,
    };
    if (asset === 'DASH') {
      return;
    }
    if (asset === 'ETH') {
      this.setState({ depositType: '' });
    }
    dispatch(fetchAddress(data))
      .then((res) => {
        if (res.type === 'FETCH_ADDRESS_SUCCESS') {
          this.handleAddresses();
        }
      });
    await this.checkNetwork();
  }

  handleAddresses() {
    const { dispatch, coins } = this.props;
    const { walletAddresses } = this.state;

    let useAddresses;

    if (coins && coins.length) {
      useAddresses = coins.filter((item) => {
        return !item.autoBuy || (item.autoBuy === false);
      });
    }

    if (!useAddresses || !useAddresses.length) {
      this.newAddress();
    }

    this.setState({ walletAddresses: useAddresses, addressLoaded: true });
  }

  // event handler for when the user changes the ethereum network in metamask
  onChainChange = event => {
    if (parseInt(event) !== 1) {
      this.setState({ metaMaskInvalidNet: true })
    } else {
      this.setState({ metaMaskInvalidNet: false })
    }
  }

  async checkNetwork() {
    if (this.ethereum) {

      // event handler for when the user changes the ethereum network in metamask
      this.ethereum.on('chainChanged', this.onChainChange);

      await this.ethereum
        .request({
          method: 'net_version'
        })
        .then(async (res) => {
          if (parseInt(res) !== 1) {
            this.setState({ metaMaskInvalidNet: true })
          }
        })
        .catch((err) => {
        });
    }
  }

  newAddress() {
    const { dispatch, asset } = this.props;
    const data = {
      asset,
    };
    dispatch(createAddress(data))
    .then((res) => {
      if (res.type === 'CREATE_ADDRESS_SUCCESS') {
        this.setState({createdAddress: res.payload.address});
      }
    });
  }

  changeEth = async () => {
    if (this.ethereum) {
      await this.ethereum
        .request({
          method: 'wallet_requestPermissions',
          params: [
            {
              eth_accounts: {}
            }
          ]
        })
        .then(async (res) => {
          const accounts = await this.ethereum.request({ method: 'eth_requestAccounts' });
          await this.fetchBalance(accounts[0])
          this.setState({
            depositType: 'METAMASK',
          });
        })
        .catch((err) => {
          this.setState({
            depositType: '',
            metaMaskAccount: null
          });
        });
    }
  }

  fetchBalance = async (address) => {
    if (this.ethereum) {
      await this.ethereum
        .request({
          method: 'eth_getBalance',
          params: [address,'latest']
        })
        .then(async (res) => {
          const weiInt = parseInt(res,16);
          const ethInt = Big(weiInt).div(1_000_000_000_000_000_000).toFixed(8);
          this.setState({
            metaMaskAccount: address,
            metaMaskAccountBalance: ethInt
          });
        })
        .catch((err) => {
          this.setState({
            metaMaskAccount: null,
            metaMaskAccountBalance: null
          });
        });
    }
  }

  handleMetaMaskDepositAmount(event){
    this.setState({ [event.target.name]: event.target.value });
  }

  async triggerMetaMaskDeposit() {
    const { coins, erc20 } = this.props;
    const { metaMaskAccount, depositAmount } = this.state;

    let latestAddress;
    let useLatestAddress;

    if (coins && (coins.length || coins.address)) {
      latestAddress = coins.address || coins[0].address;
    }

    if (latestAddress) {
      useLatestAddress = latestAddress;
    }

    if (erc20) {
      if (latestAddress && !latestAddress.startsWith('0x')) {
        useLatestAddress = '0x' + latestAddress;
      }
    }
    const value = Big(depositAmount).times(1_000_000_000_000_000_000).toFixed()
    const hexValue = parseInt(value, 10).toString(16)

    await this.ethereum
    .request({
      method: 'eth_sendTransaction',
      params: [{
        to: latestAddress,
        from: metaMaskAccount,
        value: hexValue
      }]
    })
    .then(async (res) => {
      this.setState({
        metaMaskSuccess: true,
      });
    })
    .catch((err) => {
      console.log(err)
    });
  }

  async metaMaskCancel() {
    this.setState({
      depositType: '',
      metaMaskSuccess: false,
      metaMaskAccount: null,
      metaMaskAccountBalance: null,
    });
  }

  copyToClipboard(e) {
    this.depositaddress.select();
    document.execCommand('copy');
    e.target.focus();
  }

  render() {
    const { errors, coins, asset, humAsset, urlAsset, assetPending, assetSettled, assetNet, assetConf, tempAnon, erc20 } = this.props;
    const { showOld, addressLoaded, metaMaskAccount, metaMaskAccountBalance, metaMaskInvalidNet, depositType, depositAmount, metaMaskSuccess, walletAddresses, createdAddress } = this.state;
    const sideBG = {
      backgroundImage: `url(${process.env.REACT_APP_CDN + '/assets/images/modal-shape.png'})`,
    };

    let latestAddress;
    let useLatestAddress;

    // if (coins && (coins.length || coins.address)) {
    //   latestAddress = coins.address || coins[0].address;
    // }
    if (walletAddresses && (walletAddresses.length || walletAddresses.address)) {
      latestAddress = walletAddresses.address || walletAddresses[0].address;
    }

    if (latestAddress) {
      useLatestAddress = latestAddress;
    }
    if (createdAddress) {
      useLatestAddress = createdAddress;
    }

    if (erc20) {
      if (latestAddress && !latestAddress.startsWith('0x')) {
        useLatestAddress = '0x' + latestAddress;
      }
      if (createdAddress && !createdAddress.startsWith('0x')) {
        useLatestAddress = '0x' + createdAddress;
      }
    }

    let reqConfirmations = 6;

    if (assetConf && assetConf.transfers && assetConf.transfers.confirmations) {
      reqConfirmations = assetConf.transfers.confirmations;
    }

    let depositMin;
    let depositFee;

    if (assetConf && assetConf.deposit) {
      if (assetConf.deposit.min) {
        depositMin = assetConf.deposit.min;
      }
      if (assetConf.deposit.fee) {
        depositFee = assetConf.deposit.fee;
      }
    }

    return (
      <div className="withdep">
        <ToastHandler errors={errors} />

        {useLatestAddress && addressLoaded ? (
          <div className="grid-x modal-main">
            <div className="modal-title">
              <div className={'card-coin ' + urlAsset.toLowerCase()}>
                <img alt={humAsset} src={ process.env.REACT_APP_CDN + '/assets/icons/assets/' + urlAsset.toLowerCase() + '.svg'} />
              </div>
              <span>
                {asset} Account
              </span>
            </div>
            <div className="cell small-12 medium-12 large-12">
              <div className="modal-heading">Deposit to Vaultoro</div>
            </div>
            {depositType ? (
              <>
                {depositType === 'VAULTORO' ? (
                  <>
                    <div className="cell small-12 medium-12 large-12">
                      <div
                        className={tempAnon ? 'qr-con eyeblur' : 'qr-con'}
                      >
                        {useLatestAddress && (
                          <QRCode
                            value={useLatestAddress ? useLatestAddress.toString() : ''}
                          />
                        )}
                      </div>
                    </div>
                    <div className="cell small-12 medium-12 large-12 wd-info">
                      <div className="lr-p">
                        <span>
                          <b>Min Deposit:</b> {depositMin}
                        </span>
                        <span>
                          <b>Deposit Fee:</b> {depositFee}
                        </span>
                      </div>
                    </div>
                    <div className="cell small-12 medium-12 large-12">
                      <div className="input-copy-wrap no-m">
                        <div className="input-wrapper">
                          <input
                            className="modal-input"
                            type={tempAnon ? 'password' : 'text'}
                            name="depositaddress"
                            placeholder="Deposit Address"
                            value={useLatestAddress}
                            readOnly
                            ref={(depositaddress) => this.depositaddress = depositaddress}
                          />
                        </div>
                        <button type="button" disabled={!useLatestAddress} className="vlt-button" onClick={this.copyToClipboard}>
                          <span>
                            <FontAwesomeIcon
                              style={
                                useLatestAddress ? { color: '#9b4c25' } : { color: '#5e5e5e' }
                              }
                              size="lg"
                              icon={faCopy}
                            />
                          </span>
                        </button>
                      </div>
                    </div>
                    {erc20 && asset === 'ETH' ? (
                      <div className="cell small-12 medium-12 large-12">
                        <button className="vlt-button white-b" style={{marginTop: '16px'}} onClick={() => this.setState({depositType: ''})}>
                          <span>
                            Back
                          </span>
                        </button>
                      </div>
                    ) : null }

                  </>
                ) : null}

                {depositType === 'METAMASK' ? (
                  <>
                    {erc20 && asset === 'ETH' && metaMaskAccount &&
                      <>
                        {metaMaskSuccess ? (
                          <>
                            <div className="cell small-12 medium-12 large-12 text-center">
                              <img alt="MetaMask" src={ process.env.REACT_APP_CDN + '/assets/images/brands/metamask.svg'} style={{height: '80px'}}/>
                            </div>
                            <div className="cell small-12 medium-12 large-12">
                              <h2>MetaMask Deposit Request Confirmed</h2>
                              <p>Your request to deposit <b>{depositAmount} {asset}</b> has been successfully requested via Metamask. You can track it&apos;s status through your MetaMask extension.</p>
                            </div>
                            <div className="cell small-12 medium-12 large-12 wd-info">
                              <div className="button-area" style={{marginTop: '16px'}}>
                                <button className="vlt-button white-b" onClick={() => this.props.toggleModal(null)}>
                                  <span>
                                    Close
                                  </span>
                                </button>
                                <button className="vlt-button" onClick={this.metaMaskCancel}>
                                  <span>
                                    Make another deposit
                                  </span>
                                </button>
                              </div>
                            </div>
                          </>
                        ) : (
                          <>
                            <div className="cell small-12 medium-12 large-12 wd-info">
                              <div className="lr-p">
                                <span>
                                  <b>Min Deposit:</b> {depositMin}
                                </span>
                                <span>
                                  <b>Deposit Fee:</b> {depositFee}
                                </span>
                              </div>
                            </div>
                            <div className="cell small-12 medium-12 large-12 wd-info">
                              <div className="input-wrapper" style={{display: 'flex'}}>
                                <img style={{marginRight: '8px'}} alt="MetaMask" src={ process.env.REACT_APP_CDN + '/assets/images/brands/metamask.svg'} />
                                <input
                                  className="modal-input"
                                  type="number"
                                  step="0.01"
                                  name="depositAmount"
                                  disabled={metaMaskInvalidNet}
                                  placeholder="Deposit Amount"
                                  onChange={this.handleMetaMaskDepositAmount}
                                />
                              </div>
                              {!metaMaskInvalidNet &&
                                <div className="lr-p">
                                  <span>
                                    <b>Connected address:</b> {metaMaskAccount}
                                  </span>
                                  <span>
                                    <b>Available balance:</b> {metaMaskAccountBalance}
                                  </span>
                                </div>
                              }
                              <div className="button-area" style={{marginTop: '16px'}}>
                                <button style={{ width: '100%' }} className="vlt-button white-b" onClick={this.metaMaskCancel}>
                                  <span>
                                    Cancel
                                  </span>
                                </button>
                                <button style={{ width: '100%' }} className="vlt-button" disabled={metaMaskInvalidNet || (depositAmount <= 0) } onClick={this.triggerMetaMaskDeposit}>
                                  <span>
                                    Initiate Deposit
                                  </span>
                                </button>
                              </div>
                              {metaMaskInvalidNet &&
                                <small className="text-center mute" style={{display: 'block', marginTop: '4px'}}>
                                  Invalid network. Please switch to the Ethereum Mainnet in MetaMask.
                                </small>
                              }
                            </div>
                          </>
                        )}
                      </>
                    }
                  </>
                ) : null}
              </>
            ) : (
              <>
                <div className="cell small-12 medium-12 large-12">
                  <p>How would you like to deposit your {asset}?</p>
                </div>
                <div className="cell small-12 medium-12 large-12 wd-info">
                  <button style={{ width: '100%', height: '60px'}} className="vlt-button" onClick={() => this.setState({depositType: 'VAULTORO'})}>
                    <span>
                      Deposit via Address
                    </span>
                  </button>
                </div>
                {erc20 && asset === 'ETH' && !metaMaskAccount &&
                  <div className="cell small-12 medium-12 large-12 wd-info" style={{marginTop: '16px'}}>
                    <button style={{ width: '100%', height: '60px'}} className="vlt-button" disabled={typeof this.ethereum === 'undefined' || metaMaskInvalidNet} onClick={this.changeEth}>
                      <span>
                        <img alt="MetaMask" src={ process.env.REACT_APP_CDN + '/assets/images/brands/metamask.svg'} />
                      </span>
                      <span>
                        Deposit via MetaMask
                      </span>
                    </button>
                    {typeof this.ethereum === 'undefined' &&
                      <small className="text-center mute" style={{display: 'block', marginTop: '4px'}}>
                        MetaMask not found. <a href="https://metamask.io/" target="_blank" rel="noreferrer">Click here to install</a>.
                      </small>
                    }
                    {metaMaskInvalidNet &&
                      <small className="text-center mute" style={{display: 'block', marginTop: '4px'}}>
                        Invalid network. Please switch to the Ethereum Mainnet in MetaMask.
                      </small>
                    }
                  </div>
                }
              </>
            )}
            <div className="cell small-12 medium-12 large-12 wd-info">
              <p className="wdi-head">Please Note</p>
              {erc20 && (
                <p>
                  There are charges for creating an address & depositing. For more information <a href="https://support.vaultoro.com/hc/en-us/articles/360019395699-Deposit-and-Withdrawals-Limits-and-Fees" target="_blank" rel="noopener noreferrer">click here</a>.
                </p>
              )}
              <p>
                Only send
                <span style={{ textTransform: 'uppercase' }}> {asset} </span>
                to this deposit address. Sending any other coin or token to this address may result in the loss of your deposit.
              </p>
              <p>
                {erc20 ? (
                  null
                ) : (
                  `Your deposit will be credited after a mininum of ${reqConfirmations} network confirmations. `
                )}
                After making a deposit, you can track its progress on the
                <a href="/history"> history page</a>
                .
              </p>
            </div>
          </div>
        ) : (
          <div className="grid-x modal-main">
            <div className="modal-title">
              <div className={'card-coin ' + urlAsset.toLowerCase()}>
                <img alt={humAsset} src={ process.env.REACT_APP_CDN + '/assets/icons/assets/' + urlAsset.toLowerCase() + '.svg'} />
              </div>
              <span>
                {asset} Account
              </span>
            </div>
            <div className="cell small-12 medium-12 large-12">
              <div className="modal-heading">Deposit to Vaultoro</div>
            </div>

            <div className="cell small-12 medium-12 large-12">
              <div className="center-loader" style={{ minHeight: 200 }}>
                <Loader logo dark />
              </div>
            </div>
          </div>
        )}

        <div className="modal-side">
          <div className="modal-close" onClick={() => this.props.toggleModal(null)}>
            <img alt="close" src={ process.env.REACT_APP_CDN + '/assets/icons/close-w.svg'} />
          </div>
          <div style={sideBG} className="ms-content">
            <div className="ms-head">
              <div className={'card-coin ' + urlAsset.toLowerCase()}>
                <img alt={humAsset} src={process.env.REACT_APP_CDN + '/assets/icons/assets/' + urlAsset.toLowerCase() + '.svg'} />
              </div>
              <div className="ms-head-title">
                {asset} Account
              </div>
            </div>
            <div className="ms-table">
              <div className="mst-row">
                <div>Settled Balance</div>
                <div className="num">
                  {assetSettled} {asset}
                </div>
              </div>
              <div className="mst-row">
                <div>Blocked Balance</div>
                <div className="num">
                  {assetPending} {asset}
                </div>
              </div>
              <div className="mst-row">
                <div>Available Balance</div>
                <div className="num">
                  {assetNet} {asset}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  balance: state.balance.balance,
  coins: state.coins.coins,
  errors: state.coins.errors,
  tempAnon: state.user.tempAnon,
});

export default connect(mapStateToProps)(DepositModal);
